import React from 'react';
import Component from '../../components/Component';
import DbInfo from '../../dbinfo';
import * as Constants from '../../constants';
import ApiClient from '../../helpers/ApiClient';
import Toolbar from '../../components/Toolbar';
import {Button, ButtonToolbar} from 'react-bootstrap';
import {RxForm, FormManager, FormField, FormRow, Multiform} from 'reactis-forms';
import {TextInput, TextArea, DatePicker, RadioList, FileUpload, ImageUpload, Select, Checkbox, Number} from 'reactis-inputs';
import {actions as formactions} from 'reactis-forms';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {AlertWindow, ConfirmWindow} from 'reactis-modal';
import FormDB from '../../components/FormDB';
import {Loader, LoadingButton} from 'reactis-loader';
import ActionButton from '../../components/ActionButton';
import SaveButton from '../../components/SaveButton';
import * as naviActions from '../../redux/modules/navi';
import * as tabActions from '../../redux/modules/tabs';
import AppForm from '../../components/AppForm';
import DeleteButton from '../../components/DeleteButton';
import TableForm from '../../components/TableForm';
import TagInput from '../../components/Form/TagInput';
import ReactCrop from 'react-image-crop';

export default class Editor extends React.Component {

	constructor(props, context) {
		super(props, context);
		this.state = {
			changed: false,
			saving: false,
			crop: false
		}
	}

	save() {
		this.setState({loading: true});
		const api = new ApiClient();
		api.call('image.crop', {image: this.props.image, crop: this.state.crop}, {progress:true}).then((result) => {
			this.setState({loading: false});
			this.props.onSave(result.image);
		})
	}

	handleCropChange(val, pixels) {
		this.setState({crop: val, changed: val.height > 0});
	}

	render() {
		const saveButton = <SaveButton
			disabled={!this.state.changed}
			loading={this.state.saving}
			title="Oříznout a uložit"
			onClick={()=>this.save()}
		/>;


		return (
			<div>
				<div style={{textAlign:'center'}}>
					<ReactCrop src={this.props.image.orig}
							   onComplete={(crop, pixels) => this.handleCropChange(crop, pixels)}
							   onChange={(crop, pixels) => this.handleCropChange(crop, pixels)}
					/>
				</div>
				{this.props.popup &&
				<div className="modal-footer" style={{margin: -20, marginTop: 20}}>
					<div className="hide" style={{float:'left', textAlign:'left'}}>
						<table>
							<tbody>
								<tr>
									<td><span>poměr stran: </span></td>
									<td><Select style={{float:'left', width: 130}} value={'19/10'}
												options={[{id: 0, title: 'vlastní'}, {id: '1/1', title: '1:1'}, {id: '19/10', title: '19:10'}]} /></td>
								</tr>
							</tbody>
						</table>
					</div>
					<Button onClick={() => this.props.onClose()} bsStyle="link">Storno</Button>
					{saveButton}
				</div>}
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/containers/Image/Editor.js